<template>
  <br />
  <div class="home">
    <p v-if="showProductOnce">早知心-太原西山医院-心脏健康风险分析基础包</p>
    <p v-if="showProductYear">早知心-太原西山医院-"心"健康计划</p>
    <br />
    <div class="van-hairline--surround">
      <van-cell-group inset>
        <van-field readonly label="服务机构" placeholder="太原西山医院" />
        <van-field readonly label="技术支持" placeholder="爱立微科技" />
        <van-field v-if="showProductOnce" readonly label="支付方式" placeholder="企业支付可承担部分" />
        <van-field v-if="showProductYear" readonly label="支付方式" placeholder="医保覆盖门诊和药品部分" />
        <van-notice-bar left-icon="volume-o" text="医疗部分：门诊、用药等，医保可以有效涵盖！" />
      </van-cell-group>
    </div>
    <br />
    <van-cell-group inset>
      <van-grid direction="horizontal" :column-num="3">
        <van-grid-item icon="refund-o" text="随时可退" />
        <van-grid-item icon="good-job-o" text="专家解读" />
        <van-grid-item icon="newspaper-o" text="即查即阅" />
        <van-grid-item icon="gold-coin-o" text="资金节约" />
        <van-grid-item icon="manager-o" text="名家中医" />
        <van-grid-item icon="bulb-o" text="绿通服务" />
      </van-grid>
    </van-cell-group>
    <br />
    <van-cell-group v-if="showProductYear" inset>
      <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">项目包含</van-divider>
      <van-field readonly label="内容项(1)" model-value='早知心心健康季度分析，全年4次。' />
      <van-field readonly label="内容项(2)" model-value="公全年健康管理过程数字化，超20项关键医疗内容全路径记录，个人可评价。" />
      <van-field readonly label="内容项(3)" model-value="各个环节人工服务，沟通和结果追踪。" />
      <van-field readonly label="内容项(4)" model-value="独享专有健康专员服务，全程跟踪健康计划。" />
      <van-field readonly label="内容项(5)" model-value="年度效果总结。" />
      <van-field readonly label="特点1:" model-value='医保全程覆盖，极大节省个人支出' left-icon="smile-o" right-icon="fire-o" />
      <van-field readonly label="特点2:" model-value="公立医院主任医生，省级名医" left-icon="manager-o" />
      <van-field readonly label="特点3:" model-value="数字化手段将国内知名专家经验沉淀，保证最终效果" left-icon="good-job-o" />
    </van-cell-group>
    <br />
    <van-cell-group v-if="showProductOnce" title="" inset>
      <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">了解血管阻塞风险</van-divider>
      <div class="video-container">
        <video id="player-container-id"  width="360" height="220" preload="auto" playsinline webkit-playsinline controls autoplay></video>
    </div>
    </van-cell-group>
    <br/>
    <van-cell-group v-if="showProductOnce" title="" inset>
      <van-divider
        :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">(1)与顶级专家学习，更为精准的分析心脏的当前风险状态</van-divider>
      <van-image src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/pglc.png" />
    </van-cell-group>
    <van-cell-group v-if="showProductYear" title="" inset>
      <van-divider
        :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">86%的用户精准识别风险，通过生活注意事项就可以有效降低患病的发生</van-divider>
      <van-image src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/weibing.png" />
    </van-cell-group>
    <br />
    <van-cell-group v-if="showProductOnce" title="" inset>
      <van-divider
        :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">(2)风险的分级管理更有利于个人健康准确把握，减少个人和家庭的负担</van-divider>
      <van-image src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/aicacs.png" />
    </van-cell-group>
    <van-cell-group v-if="showProductYear" title="" inset>
      <van-divider
        :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">心血管病的风险防控，需要个人更为重视早期识别和预防</van-divider>
      <van-image src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/xzb.png" />
    </van-cell-group>
    <br />
    <van-cell-group v-if="showProductOnce" title="" inset>
      <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">(3)“检查+评估+管理”一体方案，充分使用企业支付和医疗保险，个人支付比低</van-divider>
      <van-image src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/zhifu.png" />
    </van-cell-group>
    <van-cell-group v-if="showProductYear" title="" inset>
      <van-divider
        :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">更早的建立适合自己的、可持续的预防方案是关键</van-divider>
      <van-image src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/shijianzhou.png" />
    </van-cell-group>
    <br />

    <van-submit-bar :price="productInfo.ProductVo.personFee * 100" button-text="提交订单" tip-icon="info-o"
      @submit="saveOrder">
    </van-submit-bar>
    <van-popup v-model:show="showStep" round closeable close-icon="close" position="bottom" :style="{ height: '10%' }">
      <van-notice-bar wrapable :scrollable="false" left-icon="info-o">
        {{ popupTx }}
      </van-notice-bar>
    </van-popup>
  </div>
</template>
<script>
import { getCheckInformed } from '../../api/permission'
import { ref, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { postUserLog } from "../../api/userlog";
import request from '../../utils/request';
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
export default {
  setup() {
    const router = useRouter();
    const showProductOnce = ref('false');
    const showProductYear = ref('false');
    const popupTx = ref('');
    const showStep = ref(false);
    let player = reactive(null);
    const ulog = reactive({
            UserLog: {
                 path: "",
            },
        });
    const productInfo = reactive({
      ProductVo: {
        id: '',
        productCode: '',
        productName: '',
        descOne: '',
        descTwo: '',
        descThree: '',
        descFour: '',
        descFive: '',
        hospId: '',
        hospName: '',
        personFee: '',
        allFee: '',
        corporatePay: '',
        img: '',
        tag: '',
        operation: '',
        isCorporate: '',
      }
    })
    const state = reactive({
      Informed: {
        informedFlag: '',
      }
    });
    const showStepPopup = () => {
      showStep.value = true;
    };
    const saveOrder = () => {
      router.push('/personOrder/' + productInfo.ProductVo.productCode);
    }
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      player = TCPlayer('player-container-id',
        {
          fileID: '3270835011401311705', // 请传入需要播放的视频 fileID（必须）
          appID: '1258265833', // 请传入点播账号的 appID（必须）
          psign: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6MTI1ODI2NTgzMywiZmlsZUlkIjoiMzI3MDgzNTAxMTQwMTMxMTcwNSIsImN1cnJlbnRUaW1lU3RhbXAiOjE2OTgxMjIwNTEsImNvbnRlbnRJbmZvIjp7ImF1ZGlvVmlkZW9UeXBlIjoiT3JpZ2luYWwifSwidXJsQWNjZXNzSW5mbyI6eyJkb21haW4iOiIxMjU4MjY1ODMzLnZvZDIubXlxY2xvdWQuY29tIiwic2NoZW1lIjoiSFRUUCJ9fQ.E4UcqZX7NsmAdiwTYoXR5UEsIH2QL_AMzRz5wMKOoPQ',  
          licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1258265833_1/v_cube.license',
        });
      console.log('router:', router.currentRoute.value.params.productCode)
      if (router.currentRoute.value.params.productCode == 'AilywayOnce') {
        showProductOnce.value = true;
        showProductYear.value = false;
      } else if (router.currentRoute.value.params.productCode == 'HeartPlan') {
        showProductOnce.value = false;
        showProductYear.value = true;
      } else {
        showProductOnce.value = false;
        showProductYear.value = false;
      }
      request.get('/wxmanager/person/findProductVoByCode', {
        params: {
          productCode: router.currentRoute.value.params.productCode
        }
      }).then((res) => {
        productInfo.ProductVo = res.data.data;
        console.log(productInfo.ProductVo);
      })
      getCheckInformed().then((res) => {
        console.log(res.data.code);
        const binding = res.data.code;
        if (binding == 60001) {
          state.Informed.informedFlag = true;
        } else if (binding == 60002) {
          state.Informed.informedFlag = false;
        } else {
          state.Informed.informedFlag = false;
        }
      })
    })
    return {
      // onSubmit,
      player,
      productInfo,
      state,
      saveOrder,
      showProductOnce,
      showProductYear,
      showStepPopup,
      showStep,
      popupTx,
    };
  }
};
</script>


